import './App.css';
import Background from './components/Background';
import Footer from './components/Footer';
import Header from './components/Header';
import Projects from './components/Projects';
import Experience from './components/Experience';

function App() {
  return (
    <div className="App">
      <Header/>
      <Background/>
      <Projects/>
      <Experience/>
      <Footer/>
    </div>
  );
}

export default App;
